import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { Avatar, Text, Icon } from '@atomic';
import { COLOR_FONT_GRAY } from '@assets/color';
import RedHeart from '@assets/icon/icn_heart_red.svg';
import DefaultHeart from '@assets/icon/icn_heart_transparent.svg';
import FollowText from './FollowText';

const UserInfoContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const UserContainer = styled.div`
  display: flex;
  align-items: center;
`;

const TextWrapper = styled.div``;

const avatarStyle = {
  display: 'inline-block',
  marginRight: '8px',
};

function UserInfo({ user, isFollow, isLike, ...props }) {
  const { image: avatarUrl, fullName, followers } = user;

  console.log(user);
  return (
    <UserInfoContainer {...props}>
      <UserContainer>
        <Avatar style={avatarStyle} avatarUrl={avatarUrl} borderSize={35} />
        <TextWrapper>
          <FollowText userName={fullName} isFollow={isFollow} />
          <Text block textSize={14} textColor={COLOR_FONT_GRAY}>
            follower {followers.length}
          </Text>
        </TextWrapper>
      </UserContainer>
      <Icon
        src={isLike ? RedHeart : DefaultHeart}
        clickable
        iconSize={24}
        style={{
          display: 'inline-flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      />
    </UserInfoContainer>
  );
}

UserInfo.propTypes = {
  user: PropTypes.object,
  isFollow: PropTypes.bool,
  isLike: PropTypes.bool,
};

export default UserInfo;
